import type { Config } from '@/config/types.ts'; // 预发环境配置

// 预发环境配置
const config: Partial<Config> = {};

export default config;
